export default {
  home: {
    title: 'Home',
    welcome: 'Welcome to My Website'
  },
  about: {
    title: 'About',
    description: 'This is a multilingual website built with Vue.js'
  },
  navigation: {
    home: 'Home',
    about: 'About',
    language: 'Language',
    languageChose: 'Language Selection',
    en: 'English',
    zh: 'Chinese',
    ja: 'Japanese',
    getScheme: 'Get Solution',
    solution: 'Solutions',
    joinType: 'Onboarding',
    joinNow: 'Join Now',
    aboutUs: 'About Us',
    businessModel: 'Business Model'
  },
  notFound: {
    title: 'Page Not Found',
    message: 'The page you are looking for does not exist'
  }
}